<template>
    <div class="crorect-info-page">
      <div class="title">
          <div class="title-left">
            <div class="row-1">
              {{ papername }}
            </div>
            <div class="score">
              <span>得分</span> {{user_score}}/{{paper_score}}
            </div>
          </div>
          <div class="title-right">
              <el-button
                      type="primary"
                      size="middle"
                      :disabled="is_publish"
                      @click="publish"
                      >
                  发布给学员
              </el-button>
          </div>
      </div>
        <div class="content">
            <div class="content-container">
            <el-tabs type="border-card" @tab-click="tabClick" class="page-tab">
              <el-tab-pane v-for="(item,index) in question_list" :key="index"

              >
                <span slot="label"><img src="../../../static/images/paper_status.png" class="status_image" v-show="item.teacherRemark"> {{ item.question_num }}</span>
                <!-- 材料 -->
                <div class="part" v-if="item.materialExist">
                    <div class="item-title">材料</div>
                    <div class="item-content">
                      <span class="blue" @click="viewMetrail(item)">查看材料</span>
                    </div>
                </div>
                <div class="stem">
                    <div class="item-title">题干</div>
                    <div class="item-content" v-html="item.question_stem">

                    </div>
                </div>
                <div class="time-info clearfix">
                    <div class="left time"><span class="item-title">用时:</span> <span class="item-content">{{ item.answer_duration }}</span></div>
                    <div class="left score"><span class="item-title">得分:</span> <span class="item-content">{{ item.answer_score }}/{{ item.question_score }}</span></div>
                </div>
                <!-- 学员作答and评分标准 -->
                <div class="part part-flex">
                  <div class="left">
                    <div class="item-title">学员作答</div>
                    <div>
                      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane label="答题卡作答" name="first"></el-tab-pane>
                        <el-tab-pane label="文字作答" name="second"></el-tab-pane>
                        <el-tab-pane label="图片作答" name="third"></el-tab-pane>
                      </el-tabs>
                    </div>
                    <div class="item-content" ref="box" style="position: relative;">
                      <div class="part-1" ref="first">
                        <div class="part-title">
                          答题卡作答
                        </div>
                        <div class="part-content">
                          <el-upload
                            action="#"
                            :file-list="item.user_answer_card"
                            list-type="picture-card"
                            :auto-upload="false">
                              <i slot="default" class="el-icon-plus"></i>
                              <div slot="file" slot-scope="{file}" style="width: 100%; height: 100%;">
                                <img
                                  class="el-upload-list__item-thumbnail"
                                  :src="file.url" alt=""
                                >
                                <span class="el-upload-list__item-actions">
                                  <span
                                    class="el-upload-list__item-preview"
                                    @click="handlePictureCardPreview(file.url)"
                                  >
                                    <i class="el-icon-zoom-in"></i>
                                  </span>
                                  <span
                                    v-if="!is_publish"
                                    class="el-upload-list__item-delete"
                                    @click="handleDownload(file)"
                                  >
                                    <i class="el-icon-download"></i>
                                  </span>
                                </span>
                              </div>
                          </el-upload>
                          <div class="all-words" v-show="!item.user_answer_card || !item.user_answer_card.length">
                            <div>无</div>
                          </div>
                        </div>
                      </div>
                      <div class="part-1" ref="second">
                        <div class="part-title">
                          文字作答
                        </div>
                        <div class="part-content">
                          <div class="all-words" v-for="(content_standard,content_standard_index) in item.content_standard"  :key="content_standard_index">
                            <div v-html="content_standard.str"></div>
                          </div>
                          <div class="all-words" v-show="!item.content_standard || !item.content_standard.length ">
                            <div>无</div>
                          </div>
                        </div>
                      </div>
                      <div class="part-1" ref="third">
                        <div class="part-title">
                          图片作答
                        </div>
                        <div class="part-content">
                          <img :src="img_url" class="image" @click="handlePictureCardPreview(img_url)" v-for="img_url in item.question_pic">
                          <div class="all-words" v-show="!item.question_pic || !item.question_pic.length ">
                            <div>无</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="right">
                    <div class="item-title">评分标准</div>
                    <div>
                      <el-tabs v-model="activeName2" type="card" @tab-click="handleClick2">
                        <el-tab-pane label="内容采分点" name="first_1"></el-tab-pane>
                        <el-tab-pane label="结构采分点" name="second_1"></el-tab-pane>
                      </el-tabs>
                    </div>
                    <div class="item-content" ref="box2" style="position: relative;">
                      <div class="part-1" ref="first_1">
                        <div class="part-title">
                          内容采分点
                        </div>
                        <div class="part-content">
                          <div class="answer-content-item" v-for="(content_standard,content_standard_index) in item.content_standard" :key="content_standard_index">
                              <div class="answer-type"><img src="../../../static/images/papertype.png" class="image">{{ content_standard.score_section_name }}</div>
                              <div class="score-point">
                                  <el-card class="box-card" v-for="(content_standard_point,content_standard_point_index) in content_standard.section" :key="content_standard_point_index">
                                      <el-row>
                                          <el-col :span="6">
                                              <span class="font-s">采分点：</span>{{ content_standard_point.max_score }}分
                                          </el-col>
                                          <el-col :span="7">
                                              <span class="font-s">学员得分：</span><span class="student-score">{{ content_standard_point.score }}分</span>
                                          </el-col>
                                          <el-col :span="11" class="correction-score">
                                              <span class="font-s">修正得分：</span>
                                              <span class="student-score">{{ content_standard_point.revise_score }}分</span>
                                              <!-- <el-input maxlength=20 clearable :span="6" v-model="content_standard_point.revise_score" @blur="modifyScore(content_standard_point.revise_score,index,content_standard_index,content_standard_point_index)" @focus="$event.target.select()" :disabled="is_publish"></el-input> 分
                                              <span class="score-error" v-show="!content_standard_point.is_error">{{ content_standard_point.error_tip }}</span> -->
                                          </el-col>
                                      </el-row>
                                      <div class="key-item" v-for=" (content_standard_point_item,index_line) in content_standard_point.keyline " :key="index_line">
                                          <div class="key-line">关键句{{ index_line + 1 }}：<span :class="content_standard_point_item.if_choose==1?'choose':''">{{ content_standard_point_item.keyline }}({{ content_standard_point_item.max_score }}分)</span></div>
                                          <div class="key-word" v-for="(content_standard_point_item_key,key_index) in content_standard_point_item.keyword" :key="key_index">关键词{{ key_index + 1 }}：{{ content_standard_point_item_key }}</div>
                                      </div>
                                  </el-card>
                              </div>
                          </div>
                          <div class="answer-content-item" v-show="!item.content_standard || !item.content_standard.length">无</div>
                        </div>
                      </div>
                      <div class="part-1" ref="second_1">
                        <div class="part-title">
                          结构采分点
                        </div>
                        <div class="part-content">
                          <div v-for="(structure_item,structure_item_index) in item.structure_standard" class="answer-content-item">
                              <div class="answer-type score-point">
                                  <el-row>
                                      <el-col :span="6">
                                          <img src="../../../static/images/papertype.png" class="image">{{ structure_item.score_section_name }}
                                      </el-col>
                                      <el-col :span="7" v-show="item.question_mode==1">
                                          <span class="font-s">学员得分：</span><span :class="structure_item.max_score>structure_item.answer_score?'student-score red':'student-score'">{{ structure_item.answer_score    }}分</span>
                                      </el-col>
                                      <el-col :span="7" v-show="item.question_mode==0">
                                          <span class="font-s">学员扣分：</span><span :class="structure_item.answer_score > 0?'student-score red':'student-score'">{{ structure_item.answer_score    }}分</span>
                                      </el-col>
                                      <el-col :span="11" class="correction-score">
                                          <span class="font-s">{{ item.question_mode == 0?"修正扣分":"修正得分" }}：</span>
                                          <span class="student-score">{{ structure_item.revise_score }}分</span>
                                          <!-- <el-input maxlength=20 clearable :span="6" v-model="structure_item.revise_score"  @blur="modifyStructureScore(index,structure_item_index)" @focus="$event.target.select()" :disabled="is_publish"></el-input> 分
                                          <span class="score-error" v-show="!structure_item.is_error">{{ structure_item.error_tip }}</span> -->
                                      </el-col>
                                  </el-row>
                              </div>
                              <div class="score-point">
                                  <el-card class="box-card">
                                      <div class="key-item" v-for="structure_item_section in structure_item.sections">
                                          <div :class="structure_item_section.if_choose==1?'key-line choose':'key-line'">{{ structure_item_section.check_name }}({{ structure_item_section.score }}分)</div>
                                      </div>
                                  </el-card>
                              </div>
                          </div>
                          <div class="answer-content-item" v-show="!item.structure_standard || !item.structure_standard.length">无</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 用户作答完毕 -->
                <div class="user-answer">
                  <div class="item-answer clearfix">
                      <div class="item-title left half">作答分析</div>
                  </div>
                    <!-- 总体评价 -->
                    <div class="item-answer clearfix" v-show="item.question_mode==0">
                        <div class="answer-title">总体评价
                            <div v-show="item.answer_evaluate" @click="openClose(index,'is_evaluate')">
                                <span class="open-close" v-show="item.is_evaluate">收起 <span class="el-icon-arrow-up"></span></span>
                                <span class="open-close" v-show="!item.is_evaluate">展开 <span class="el-icon-arrow-down"></span></span>
                            </div>
                            </div>
                        <div class="des-info" v-show="item.answer_evaluate && item.is_evaluate">{{ item.answer_evaluate }}</div>
                    </div>
                    <!-- 问题诊断 -->
                    <div class="item-answer clearfix" v-show="item.question_mode==1">
                        <div class="answer-title">问题诊断
                            <div @click="openClose(index,'is_diagnose')">
                                <span class="open-close" v-show="item.is_diagnose">收起 <span class="el-icon-arrow-up"></span></span>
                                <span class="open-close" v-show="!item.is_diagnose">展开 <span class="el-icon-arrow-down"></span></span>
                            </div>
                        </div>
                        <div v-show="is_click"></div>
                        <div v-show="item.is_diagnose" class="diagnose_content">
                            <p v-html="item.answer_diagnose.header_text"></p>
                            <p  class="diagnose_type_title">缺少的要点为：</p>
                                <div v-show="item.answer_diagnose.miss_point.length==0">无</div>
                                <div v-show="item.answer_diagnose.miss_point.length!=0" v-for="diagnose_miss_item in item.answer_diagnose.miss_point">
                                    <div class="diagnose_type_title">
                                        <span v-html="diagnose_miss_item.user_answer"></span><span v-html='diagnose_miss_item.user_score'></span>
                                    </div>
                                    <p v-show="diagnose_miss_item.material_content" class="diagnose_title">对应材料：</p>
                                    <div v-html="diagnose_miss_item.material_content"   class="diagnose_item_content"></div>
                                    <p v-show="diagnose_miss_item.material_analysis"  class="diagnose_title">要点讲解：</p>
                                    <div v-html="diagnose_miss_item.material_analysis"   class="diagnose_item_content"></div>
                                </div>
                            <div class="line"></div>
                            <p  class="diagnose_type_title">不准确的要点为：</p>
                                <div v-show="item.answer_diagnose.inaccurate_point.length==0">无</div>
                                <div v-show="item.answer_diagnose.inaccurate_point.length!=0" v-for="diagnose_inaccurate_item in item.answer_diagnose.inaccurate_point">
                                    <div class="diagnose_type_title">
                                        <span v-html="diagnose_inaccurate_item.user_answer"></span><span v-html='diagnose_inaccurate_item.user_score'></span>
                                    </div>
                                    <div>
                                        <span v-html="diagnose_inaccurate_item.standard_answer"></span><span v-html='diagnose_inaccurate_item.standard_score'></span>
                                    </div>
                                    <p v-show="diagnose_inaccurate_item.material_content"  class="diagnose_title">对应材料：</p>
                                    <div v-html="diagnose_inaccurate_item.material_content"   class="diagnose_item_content"></div>
                                    <p v-show="diagnose_inaccurate_item.material_analysis"  class="diagnose_title">要点讲解：</p>
                                    <div v-html="diagnose_inaccurate_item.material_analysis"   class="diagnose_item_content"></div>
                                </div>
                        </div>
                    </div>
                    <!-- 优点 -->
                    <div class="item-answer clearfix" v-show="item.question_mode==0">
                        <div class="answer-title">优点
                            <div v-show="item.answer_merit.length!=0"  @click="openClose(index,'is_merit')">
                                <span class="open-close" v-show="item.is_merit">收起 <span class="el-icon-arrow-up"></span></span>
                                <span class="open-close" v-show="!item.is_merit">展开 <span class="el-icon-arrow-down"></span></span>
                            </div>
                        </div>
                        <div v-show="is_click"></div>
                        <div v-show="item.answer_merit.length!=0 && item.is_merit">
                            <div v-for="answer_merit_item in item.answer_merit">
                                <div class="advantage-title">{{ answer_merit_item.part_name }}：</div>
                                <div class="advantage-info" v-html="answer_merit_item.list"></div>
                            </div>
                        </div>
                    </div>
                    <!-- 问题 -->
                    <div class="item-answer clearfix" v-show="item.question_mode==0">
                        <div class="answer-title">问题
                            <div v-show="item.answer_defect.length!=0"  @click="openClose(index,'is_defect')">
                                <span class="open-close" v-show="item.is_defect">收起 <span class="el-icon-arrow-up"></span></span>
                                <span class="open-close" v-show="!item.is_defect">展开 <span class="el-icon-arrow-down"></span></span>
                            </div>
                        </div>
                        <div v-show="item.answer_defect.length!=0 && item.is_defect">
                            <div v-for="answer_defect_item in item.answer_defect">
                                <div class="advantage-title">{{ answer_defect_item.part_name }}：</div>
                                <div class="advantage-info" v-html="answer_defect_item.list"></div>
                            </div>
                        </div>
                    </div>
                    <!-- 建议 -->
                    <div class="item-answer clearfix" v-show="item.question_mode==0">
                        <div class="answer-title">建议
                            <div v-show="item.answer_advance"   @click="openClose(index,'is_advance')">
                                <span class="open-close" v-show="item.is_advance">收起 <span class="el-icon-arrow-up"></span></span>
                                <span class="open-close" v-show="!item.is_advance">展开 <span class="el-icon-arrow-down"></span></span>
                            </div>
                        </div>
                        <div class="advantage-info" v-show="item.answer_advance && item.is_advance" v-html="item.answer_advance">
                        </div>
                    </div>

                </div>
                <!-- 参考答案 -->
                <div class="stem">
                    <div class="item-title">参考答案</div>
                    <div class="item-content" v-html="item.question_correct_answer">
                    </div>
                </div>
                <!-- 答案解析 -->
                <div class="stem">
                    <div class="item-title">答案解析</div>
                    <div class="item-content" v-html="item.question_explain">
                    </div>
                </div>
                <div class="teacher-comment">
                    <div class="comment-container">
                        <el-col :span="18">
                            <el-button
                            type="primary"
                            plain
                            size="middle"
                            :disabled="!question_id_list"
                            @click="goPage(`/teacher-assess/${correct_user}/${job_id}/${job_sub_id}/${item.question_id}/${item.question_mode}/${item.question_num}/${item.question_score}/${item.user_answer_card.length}/${item.teacherRemark}`)"
                            >
                              {{is_publish ? '查看点评' : '教师点评'}}
                            </el-button>
                        </el-col>
                    </div>
                </div>
              </el-tab-pane>
            </el-tabs>
            </div>

        </div>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>

    import global_ from "../../global/index"

    export default {
        data() {
            return {
                action_type: 0,
                job_id: '',
                job_sub_id: '',
                questionTab: 0,
                activeName: 'first',
                activeName2: 'first_1',
                dialogVisible: false,
                dialogImageUrl: '',
                is_click:false,
                is_publish:false,
                content_info:'',
                papername:'',
                paper_score:'',
                user_score: '',
                question_list:"",
                question_id_list: null,
                question_img_list: null,
                correct_user: ''
            };
        },
        methods:{
            handleClick () {
              this.$nextTick(() => {
                this.$refs.box[this.questionTab].scrollTop = this.$refs[this.activeName][this.questionTab].offsetTop;
              })
            },
            handleClick2 () {
              this.$nextTick(() => {
                this.$refs.box2[this.questionTab].scrollTop = this.$refs[this.activeName2][this.questionTab].offsetTop;
              })
            },
            handlePictureCardPreview (imgUrl) {
              this.dialogImageUrl = imgUrl;
              this.dialogVisible = true;
            },
            handleDownload(file) {
              console.log('下载图片');
              // var image = new Image();
              // // 解决跨域 Canvas 污染问题
              // image.setAttribute("crossOrigin", "anonymous");
              // image.onload = function() {
              // var canvas = document.createElement("canvas");
              // canvas.width = image.width;
              // canvas.height = image.height;
              // var context = canvas.getContext("2d");
              // context.drawImage(image, 0, 0, image.width, image.height);
              // var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
              //
              // var a = document.createElement("a"); // 生成一个a元素
              // var event = new MouseEvent("click"); // 创建一个单击事件
              // a.download = file.name || "photo"; // 设置图片名称
              // a.href = url; // 将生成的URL设置为a.href属性
              // a.dispatchEvent(event); // 触发a的单击事件
              // };
              // image.src = file.url;
              var x = new XMLHttpRequest();
              x.open("GET", file.url, true);
              x.responseType = 'blob';
              x.onload=function(e){
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = file.name || "photo";
                  a.click();
              }
              x.send();
            },
            // 跳转页面
            goPage (router) {
              const view = this.$router.resolve({
                  path:router
              })
              window.open(view.href, '_blank')
            },
            // 获获取该任务下试题对应的学员答题卡
            getQuestionAnswerSheet (job_id, cb) {
              this.$api.GETQUESTIONANSWERSHEET({job_id}).then(res => {
                if (res.retcode == 0) {
                  this.question_img_list = res.data.question_img_list; // 对象
                  cb && cb();
                } else {
                  this.question_img_list = null;
                  this.$message.error(res.message);
                }
              })
            },
            // 获取该任务下已经批改过的试题id
            getFinishedCorrectQuestionIds (job_id, cb) {
              this.$api.GETFINISHEDCORRECTQUESTIONIDS({job_id}).then(res => {
                if (res.retcode == 0) {
                  this.question_id_list = res.data.question_id_list;
                  cb && cb();
                } else {
                  this.question_id_list = null;
                  this.$message.error(res.message);
                }
              })
            },
            // 获取子任务id
            getSubJobId (job_id) {
              this.$api.GETSUBJOBID({job_id}).then(res => {
                if (res.retcode == 0) {
                  this.job_sub_id = res.data.job_sub_id;
                } else {
                  this.$message.error(res.message);
                }
              })
            },
            getinfo() {
                if (!this.question_id_list || !this.question_img_list ) {
                  return;
                }
                this.$api.GETCORRECTINFO({
                    user_record_id: this.$route.params.record_id,
                    object_id: this.$route.params.object_id,
                    object_type: this.$route.params.object_type,
                    orgin: this.$route.params.orgin,
                    // user_record_id: 65550 || this.$route.params.record_id,
                    // correct_gauge: 3 || this.$route.params.correct_gauge,
                    // orgin: 3 || this.$route.params.orgin,
                }).then((res) => {
                    if(res.retcode==0){
                        // this.is_publish = res.data.paper_status == 0 ? false:true
                        // this.papername = res.data.paper_name;
                        this.paper_score = res.data.paper_score;
                        this.user_score = res.data.user_score;
                        this.content_info = res.data;
                        this.question_list = res.data.question_list.map((v,i) => {
                            if (this.question_id_list && this.question_id_list.includes(v.question_id)) {
                              // 已点评
                              v.teacherRemark = 1;
                            } else {
                              v.teacherRemark = 0;
                            }
                            if (this.question_img_list && this.question_img_list[v.question_id]) {
                              v.user_answer_card = this.question_img_list[v.question_id].map(item => {
                                if (item.indexOf('http') < 0 && item.indexOf('https') < 0) {
                                  item = 'http://' + item
                                }
                                return {
                                  name: item,
                                  url: item
                                }
                              });
                            } else {
                              v.user_answer_card= [];
                            }
                            v.is_evaluate = true;
                            v.is_merit = true;
                            v.is_defect = true;
                            v.is_advance = true;
                            v.is_different = true;
                            v.is_diagnose = true;
                            v.question_num = '问题'+ this.toChies(i);
                            v.content_standard.map(function(h,j) {
                                // h.user_answer  表示用户文字作答
                                const word = h.user_answer;
                                const word_arr = [];
                                let str = "";
                                h.section.map(function(a,b) {
                                        if(a.text && a.position){
                                            word_arr.push(a.position.split(",")[0],a.position.split(",")[1])

                                        }

                                    h.word_arr = word_arr
                                    a.is_error = true;
                                    a.error_tip = "";
                                    return a;
                                })
                                if(word_arr.length==0){
                                     str = h.user_answer;
                                }else{
                                    for(var n=0;n<word_arr.length/2;n++){
                                        const red = h.section[n].score< h.section[n].max_score?'red':'';
                                        if(n==0){
                                            str += h.user_answer.substring(0,word_arr[n]) + "<span class='info_border "+ red +"'>" + h.user_answer.substring(word_arr[n],word_arr[n+1]-1) +"<span class='tag "+ red +"'  attr-score='"+ h.section[n].score+"分'>"+ h.user_answer.substring(word_arr[n+1]-1,word_arr[n+1]) +"</span></span>"
                                        }else{
                                            str += h.user_answer.substring(word_arr[2*n-1],word_arr[2*n]) + "<span class='info_border "+ red +"' >" + h.user_answer.substring(word_arr[2*n],word_arr[2*n+1]-1) +"<span class='tag "+ red +"' attr-score='"+ h.section[n].score+"分'>"+ h.user_answer.substring(word_arr[2*n+1]-1,word_arr[2*n+1]) +"</span></span>"

                                        }

                                    }
                                }

                                if(word_arr[word_arr.length-1]<h.user_answer.length){
                                    str += h.user_answer.substring(word_arr[word_arr.length-1],h.user_answer.length)
                                }
                                h.str = str;
                                return h;
                            })
                            v.structure_standard.map(function(h,j) {
                                h.is_error = true;
                                h.error_tip = "";
                                return h;
                            })
                            return v;
                        });

                    }else{
                        this.$message.error(res.message);
                    }


                })
            },
            viewMetrail:function(item) {
                const view = this.$router.resolve({
                    path:'/view-material/'+ item.question_id + '/' + item.question_num
                })
                window.open(view.href, '_blank')
            },
            toChies:function(num){
                    const upperNumbers= [ '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百', '千', '万', '亿']
                    const length = String(num).length
                    if (length === 1) {
                      return upperNumbers[num]
                    } else if (length === 2) {
                      if (num === 9) {
                        return upperNumbers[num]
                      } else if (num > 9 && num < 19) {
                        const index = String(num)
                        return '十' + upperNumbers[index.charAt(1)]
                      } else {
                        const index = String(num)
                        if(index.charAt(1)==9){
                            return upperNumbers[index.charAt(0)] + '十'
                        }else{
                            return upperNumbers[index.charAt(0)-1] + '十' + upperNumbers[index.charAt(1)]
                        }

                      }
                    } else {
                      return ''
                    }
            },
            openClose:function(i,type){
                this.is_click = !this.is_click;
                this.question_list[i][type] = !this.question_list[i][type];
                // this.question_list[i][type] = false;
            },
            publish:function(){
                this.$api.PUBLISHJOB({job_id: this.job_id}).then(res => {
                  console.log('发布给学员结果：', res);
                  if (res.retcode == 0) {
                    this.$message({
                      message: '发布成功',
                      type: 'success',
                      onClose: () => {
                        this.$router.go(-1);
                      }
                    });
                  } else if (res.retcode == 10009) {
                    let setTeacherRemark_item;
                    let noTeacherRemark = [];
                    this.question_list.forEach((item, index) => {
                        if (item.question_id == res.data[0]) {
                          setTeacherRemark_item = item;
                        }
                        if(res.data.includes(Number(item.question_id))){
                            noTeacherRemark.push(index + 1);
                        }
                    })
                    if (!setTeacherRemark_item || !noTeacherRemark.length) {
                      this.$message.error('前端错误-没有获取到未点评试题信息');
                      return;
                    }
                    this.$confirm('<p style="color:#bbb;"><span style="color:red;">第'+ noTeacherRemark.join("、") +'题</span>没有点评完成，只有点评完成之后，才能发布给学员</p>', '发布失败', {
                      confirmButtonText: '去点评',
                      cancelButtonText: '取消',
                      type: 'error',
                      showClose:false,
                      closeOnClickModal:false,
                      dangerouslyUseHTMLString:true,
                    }).then(() => {
                        // setTeacherRemark_item = this.question_list[0];
                        this.goPage(`/teacher-assess/${this.correct_user}/${this.job_id}/${this.job_sub_id}/${setTeacherRemark_item.question_id}/${setTeacherRemark_item.question_mode}/${setTeacherRemark_item.question_num}/${setTeacherRemark_item.question_score}/${setTeacherRemark_item.user_answer_card.length}/${setTeacherRemark_item.teacherRemark}`);
                    }).catch(() => {
                    });
                  } else {
                    this.$message.error(res.message);
                  }
                })
            },
            tabClick:function(tab) {
              // console.log('大导航：', tab);
                this.$nextTick(() => {
                    this.questionTab = tab.index;
                    this.activeName = 'first';
                    this.activeName2 = 'first_1';
                    this.$refs.box[this.questionTab].scrollTop = 0;
                    this.$refs.box2[this.questionTab].scrollTop = 0;
                    document.querySelector('.el-tabs__content').scrollTop = '0'
                })

            }
        },
        created () {
            this.action_type = this.$route.params.action_type;
            this.correct_user = this.$route.params.correct_user;
            this.is_publish = window.localStorage.getItem('user_no') != this.correct_user;
            // this.is_publish = this.action_type == 3 ? true : false;
            this.job_id = this.$route.params.job_id;
            this.papername = window.localStorage.getItem('paper_name');
            this.getSubJobId(this.job_id);
            this.getFinishedCorrectQuestionIds(this.job_id, () => {this.getinfo()});
            this.getQuestionAnswerSheet(this.job_id, () => {this.getinfo()});
            var bc = new BroadcastChannel('test_channel');
            var _this = this;
            bc.onmessage = function (ev) {
              if (_this.question_list.length) {
                _this.question_list = _this.question_list.map(item => {
                  if (item.question_id == ev.data) {
                    item.teacherRemark = 1;
                  }
                  return item;
                })
              }
            }
        }
    }
</script>

<style lang="less">
    .status_image{
        width: 15px;
        height: 15px;
        vertical-align: middle;
    }
    .diagnose_content{
       font-size: 14px;
       margin-bottom: 20px;
    }
    .diagnose_type_title{
        line-height: 47px;
    }
    .diagnose_title{
        padding-left: 16px;
        margin:0;
        line-height: 47px;
    }
    .diagnose_item_content{
        padding-left: 30px;
        line-height: 47px;
    }
    .diagnose_item_content p{
        margin:0;
    }
    .line{
        width: 100%;
        height: 1px;
        background: #ccc;
    }
    .crorect-info-page .content .el-upload.el-upload--picture-card {
      display: none;
    }
</style>
<style>
    .left{
        float: left;
    }
    .half{
        width: 50%;
        min-height: 1px;
    }
    .crorect-info-page .el-input--suffix span.el-input__suffix{
        display: none !important;
    }
    .crorect-info-page .user-answer-content{
        margin-bottom: 20px;
    }
    .crorect-info-page .item-title{
        font-size: 16px;
        line-height: 44px;
        font-weight: bolder;
    }
    .crorect-info-page .item-content{
        font-size: 14px;
        /* padding-left: 16px; */
    }
    .crorect-info-page .item-content p{
        margin:inherit !important;
        line-height: 26px;
    }
    .crorect-info-page .time-info{
        font-size: 16px;
    }
    .crorect-info-page .time-info .score{
        margin-left: 200px;
    }
    .crorect-info-page .answer-title{
        font-size: 14px;
        line-height: 66px;
        padding-left: 10px;
        box-sizing: border-box;
        position: relative;
    }
    .crorect-info-page .answer-title .open-close{
        position: absolute;
        right:0;
        top:0;
        color: #aaa;
        cursor: pointer;
    }
    .crorect-info-page .answer-title::before{
        content: "";
        position: absolute;
        left:0;
        top:25px;
        height: 15px;
        width: 3px;
        background-color: #1890ff;
    }
    .crorect-info-page{
        width: 100%;
        padding: 0 30px;
        height: 100%;
        min-height: 500px;
    }

    .crorect-info-page .operate-btn{
        float: right;
    }
    .crorect-info-page .content{
        padding-top: 100px;
        padding-bottom: 60px;
        box-sizing: border-box;
        height: 100%;
    }
    .crorect-info-page .content-container{
        height: 100%;
    }
    .crorect-info-page .page-tab.el-tabs{
        padding-top: 40px;
        padding-bottom: 10px;
        box-sizing: border-box;
        height: 100%;
    }

    .crorect-info-page .page-tab>.el-tabs__header{
        position: fixed;

    }
    .crorect-info-page .page-tab>.el-tabs__content{
        height: 100%;
        box-sizing: border-box;
        padding-top: 40px;
        overflow: auto;

    }
    .crorect-info-page .page-tab.el-tabs--border-card{
        background: inherit;
        border: none;
        box-shadow: none;
    }
    .crorect-info-page .teacher-comment{
        height: 60px;
        width: 100%;
        padding: 0 0px;
        box-sizing: border-box;
        position: fixed;
        bottom:0;
        left:0;
        z-index: 9;

    }
    .crorect-info-page .comment-container{
        box-sizing: border-box;
        padding: 12px 30px;
        background-color: #fff;
        height: 100%;
        width: 100%;
    }
    .crorect-info-page .answer-content-item{
        font-size: 14px;
        margin-top: 25px;
    }
    .crorect-info-page .score-point .box-card{
        margin-top: 14px;
    }
    .crorect-info-page .score-point .el-input{
        width: 45%;
    }
    .crorect-info-page .score-point .el-row{
        line-height: 40px;
    }

    .crorect-info-page .score-point .key-item{
        margin-top: 10px;
        line-height: 20px;
    }
    .crorect-info-page .score-point .key-item .key-line .choose,.crorect-info-page .score-point .key-item .key-line.choose{
        color: #1890ff;
    }
    .crorect-info-page .answer-left{
        text-indent: 2em;
        padding-right: 35px;
        line-height: 38px;
        box-sizing: border-box;
    }
    .crorect-info-page .image-useranswer .answer-left{
        text-indent: inherit;
    }
    .crorect-info-page .answer-left .image{
        width:45%;
        margin-right: 2%;
        height: 136px;
    }
    .crorect-info-page .answer-right .answer-type{
        line-height: 38px;
        /*text-align: center;*/
    }
    .crorect-info-page .answer-right .answer-type {
        /*margin-top: 25px;*/
        margin-bottom: 20px;
    }
/*    .crorect-info-page .answer-right .answer-type:nth-child(1){
        margin-top: 0px;
    }*/
    .crorect-info-page .structure-standard div:nth-child(1) .answer-type{
        margin-top: 0px;
    }
    .crorect-info-page .structure-standard .answer-type{
        margin-top: 25px;
    }
/*    .crorect-info-page .structure-standard .answer-type:nth-child(1){
        margin-top: 0px !important;
    }*/
    .crorect-info-page .answer-right .answer-type .image{
        vertical-align: middle;
        margin-right: 10px;
    }
    .crorect-info-page .item-answer .des-info{
        font-size: 14px;
        text-indent: 2em;
    }
    .crorect-info-page .student-score.red{
        color: red;
    }
    .crorect-info-page .font-s{
        font-size: 16px;
    }
    .crorect-info-page .correction-score{
        position: relative;
    }
    .crorect-info-page .score-error{
        color: red;
        font-size: 12px;
        position: absolute;
        top:30px;
        left:83px;
    }
    .crorect-info-page .advantage-title{
        font-size: 14px;
        line-height: 42px;
        padding-left: 10px;
    }
    .crorect-info-page .advantage-info{
        font-size: 14px;
        padding-left: 34px;
    }
    .crorect-info-page .score-point .el-card__body{
        padding:10px;
    }
    .crorect-info-page .page-tab.el-tabs--border-card>.el-tabs__header{
        border-bottom: none;
    }
    .crorect-info-page .page-tab > .el-tabs__header{
        position: fixed;
        left:0;
        top:100px;
        z-index: 10;
        width: 100%;
        padding:0 30px;
        box-sizing: border-box;
        border:none;
    }
    .crorect-info-page .page-tab > .el-tabs__header > .el-tabs__nav-wrap{
        min-width: 1280px;
        overflow:auto;
        border-top: 1px solid #dcdfe6;
        border-bottom: 1px solid #dcdfe6;
    }
    .crorect-info-page .page-tab > .el-tabs__header > .el-tabs__nav-wra > .el-tabs__nav{
        min-width: 1280px;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .crorect-info-page .page-tab > .el-tabs__content{
        height: 100%;
        box-sizing: border-box;
        overflow: auto;
        /*min-height: 600px;*/
    }
    .crorect-info-page .info_span{
        text-decoration: underline;
    }
    .crorect-info-page .info{
        line-height: 40px;
    }
    .crorect-info-page .info_border{
        /*position: relative;*/
        border-bottom: 1px #1890ff dashed;
    }
    .crorect-info-page .info_border.red{
        /*position: relative;*/
        border-bottom: 1px #f24a78 dashed;
    }
/*    .crorect-info-page .info_border .score-point{
        position: absolute;
        right:0;
        width:50px !important;
        display: inline-block;
        bottom:-26px;
        font-size:12px;
    }*/
    .crorect-info-page .info_border .tag{
        position: relative;
        /*border-bottom: 1px red dashed;*/
    }
    .crorect-info-page .info_border .tag.red:after{
        color: #f24a78;
    }
    .crorect-info-page .info_border .tag:after{
        content: attr(attr-score);
        position: absolute;
        width: 61px;
        line-height: 12px;
        top: 100%;
        left: -30px;
        color: #1890ff;
        font-size: 12px;
    }
   .clearfix:after {visibility: hidden;display: block;font-size: 0;content: " ";clear: both;height: 0;}
   .clearfix{*zoom:1;}
</style>
<style lang="less">
.crorect-info-page {
  .blue{
      color: #1890ff;
      cursor: pointer;
  }
  .title {
    height: 100px;
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    position: fixed;
    top:0;
    left:0;
    background-color: rgba(244, 248, 249, 1);
    z-index: 99;
    display: flex;
    .title-left {
      flex: 1 0 auto;
      height: 100%;
      .row-1 {
        height: 70px;
        line-height: 100px;
        font-weight: bolder;
      }
      .score {
        height: 30px;
        line-height: 30px;
        span {
          font-weight: bolder;
        }
      }
    }
    .title-right {
        flex: 0 0 auto;
        height: 100%;
        line-height: 100px;
    }
  }
  .content {
    .part {
      &.part-flex {
        display: flex;
        .item-content {
          max-height: 400px;
          overflow-y: scroll;
          overflow-x: hidden;
        }
      }
      .item-title {
        font-weight: bolder;
      }
      .item-content {
        font-size: 14px;
        line-height: 25px;
        padding: 0;
        // p {
        //     margin: none !important;
        //     margin: inherit !important;
        //     line-height: 26px;
        // }
        .part-1 {
          .part-title {
            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 4px;
                height: 17px;
                width: 3px;
                background-color: #1890ff;
            }
            font-size: 14px;
            font-weight: bolder;
            position: relative;
            height: 25px;
            padding-left: 5px;
            margin: 10px 0;
          }
          .part-content {
            .all-words {
              margin-top: 25px;
            }
            >.image{
                width:45%;
                margin-right: 2%;
                height: 136px;
            }
            .answer-type .image {
                vertical-align: middle;
                margin-right: 10px;
            }
          }
        }
      }
      .left {
        flex: 50%;
      }
      .right {
        flex: 50%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/task-info/index.vue